const config = require(`../../.ghost.json`).production;
module.exports = {
    siteUrl:
        process.env.NODE_ENV === `production`
            ? process.env.SITE_URL || config.siteUrl || `https://www.jessicachanstudios.com`
            : `http://localhost:8000`, // Site domain. Do not include a trailing slash!

    postsPerPage: 12, // Number of posts shown on paginated pages (changes this requires sometimes to delete the cache)

    siteTitleMeta: `Jessica Chan Studios | Software Engineer, javascript and React web application development, server-side architect, Python, UI/UX Design, visual design, art and illustration`, // This allows an alternative site title for meta data for pages.
    siteDescriptionMeta: `Hi, I’m Jessica. I am a software engineer living in San Francisco. I work at Pinterest and am currently working on big data online serving systems at petabyte scale serving millions of QPS. A former web platform engineer, specializing in performance and server-side architecture, I recently made the switch over to data. Oh, and I also like to draw.`, // This allows an alternative site description for meta data for pages.

    shareImageWidth: 1000, // Change to the width of your default share image
    shareImageHeight: 523, // Change to the height of your default share image

    shortTitle: `Ghost`, // Used for App manifest e.g. Mobile Home Screen
    siteIcon: `favicon.png`, // Logo in /static dir used for SEO, RSS, and App manifest
    backgroundColor: `#e9e9e9`, // Used for Offline Manifest
    themeColor: `#15171A`, // Used for Offline Manifest
};
